<ng-container *ngIf="store.selectedProject.projection; else noProjection">
  <div class="panel-wrapper">
    <go-back-button></go-back-button>
    <mat-checkbox [(ngModel)]="store.powerLineHidden" (ngModelChange)="togglePowerLineVisibility()">{{ 'HIDE_POWER_LINE' | translate }}</mat-checkbox>
  </div>
  <map
    *ngIf="showMap"
    [enableGeolocation]="false"
    [fullPage]="true"
  ></map>
</ng-container>

<ng-template #noProjection>
  <info-container labelKey="PROJECTION_NOT_SET"></info-container>
</ng-template>
